import { render } from "./RemoveDocumentModal.vue?vue&type=template&id=15147e01&scoped=true&ts=true&lang=pug"
import script from "./RemoveDocumentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveDocumentModal.vue?vue&type=script&setup=true&lang=ts"

import "./RemoveDocumentModal.vue?vue&type=style&index=0&id=15147e01&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15147e01"]])

export default __exports__